import React from "react";
import ReactDOM from "react-dom/client";
import { About } from "./components/About";
import { Account } from "./components/Account";
import { Accounts } from "./components/Accounts";
import { App } from "./App";
import { BrowserRouter, Route, Routes, Navigate } from "react-router";
import { Chat } from "./components/Chat";
import { Chats } from "./components/Chats";
import { ConfirmDialog } from "./components/ConfirmDialog";
import { Home } from "./components/Home";
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import { SearchMessages } from "./components/SearchMessages";
import { Settings } from "./components/Settings";
import "~build/console";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
	<React.StrictMode>
		<ConfirmDialog />
		<NuqsAdapter defaultOptions={{ shallow: false }}>
			<BrowserRouter>
				<Routes>
					<Route element={<App />}>
						<Route index element={<Home />} />
						<Route path="login" element={<Login />} />
						<Route path="register" element={<Register />} />
						<Route path="accounts" element={<Accounts />}>
							<Route path=":accountId" element={<Chats />}>
								<Route index element={<Navigate to="./chats" />} />
								<Route path="search" element={<SearchMessages />} />
								<Route path="chats">
									<Route index element={<Account />} />
									<Route path=":chatId/details?" element={<Chat />} />
								</Route>
							</Route>
						</Route>
						<Route element={<Accounts />}>
							<Route path="about" element={<About />} />
							<Route path="settings" element={<Settings />} />
						</Route>
					</Route>
				</Routes>
			</BrowserRouter>
		</NuqsAdapter>
	</React.StrictMode>,
);

if (navigator.serviceWorker) {
	(async () => {
		const reg = await navigator.serviceWorker.ready;
		if (!navigator.serviceWorker.controller) {
			// There is a service worker but it's not attached
			// Force attach
			// Needed at least in Firefox for hard-reload
			reg.active?.postMessage("clientsClaim");
		}
	})();
}
